import {
  Button,
  Modal,
  Form,
  Select,
  Input,
  Table,
  Tabs,
  Space,
  Alert,
  InputNumber,
  Switch,
} from "antd";
import styles from "../../index.style";
import React, { useEffect, useRef, useState } from "react";
import {
  PlusOutlined,
  DeleteOutlined,
  MinusOutlined,
  PlusCircleFilled,
  SearchOutlined,
  BarcodeOutlined,
} from "@ant-design/icons";
import { userInfoState } from "../../recoil/atoms/userInfoAtom";
import { useRecoilState } from "recoil";
import { Material } from "../../types/material.types";
import type { TabsProps } from "antd";
import { sharedInternalInfoState } from "../../recoil/atoms/sharedInternalAtom";
import MaterialsService from "../../services/materials.service";
import { useTranslation } from "react-i18next";
import { changeShowLoading } from "../../components/Spinner/Spinner";
import { Generic } from "../../types/generic.types";
import NumericPad from "../../components/NumericPad/NumericPad";
import "../Surgeries/Surgeries.css";
import { message } from "antd";
import { render } from "@testing-library/react";
import { recountAlertAlarmState } from "../../recoil/atoms/patientInfoAtom";
import EquipeService from "../../services/equipe.service";

const { Search } = Input;

function Materials(): JSX.Element {
  // DEFAULT
  const TAB_MATERIAL = "1";
  const TAB_RECOUNT = "2";
  const LABEL_COL_SPAN = 16;
  const WRAPPER_COL_SPAN = 8;
  const DEFAULT_TABLE_FILTERS = {
    filters: {},
    sorter: {},
    extra: {},
    pagination: {},
  };
  const DEFAULT_ACTIVE_PAGINATION = {
    current: 1,
    pageSize: window.innerHeight > 900 ? 12 : 7,
    showSizeChanger: true,
    totalPage: 0,
  };
  // remap dei campi per il sorting a BE (Backend)
  const REMAPPED_FIELDS = {
    materialInfo: "material_material.code",
    materialInfoDescription: "material_material.description",
    measureUnit: "measureUnit.description",
    quantity: "t.quantity",
    effectiveQuantity: "t.effectiveQuantity",
  } as Generic;

  const DEFAULT_MATRIX_ARTICLES = {
    notRecount: "",
    recount: "",
  };

  // RECOIL
  const [userInfo] = useRecoilState(userInfoState);
  const [sharedInfo] = useRecoilState(sharedInternalInfoState);

  // REACT STATE
  let [tableData, setTableData] = useState<any[]>([]);
  const [barcodeForm] = Form.useForm();
  const [searchFilter, setSearchFilter] = useState("");
  const [activeKey, setActiveKey] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [materialList, setMaterialList] = useState<Material[]>([]);
  const [materialListLength, setMaterialListLength] = useState(0);
  const [materialType, setMaterialType] = useState();
  const [materialTypesList, setMaterialTypesList] = useState<any[]>([]);
  const [materialTypeForFilter, setMaterialTypeForFilter] = useState();
  const [searchData, setSearchData] = useState(false);
  const [numberOfMaterialToLoad, setNumberOfMaterialToLoad] = useState(50);
  const [stateKey, setStateKey] = useState(0);
  const [openNumericPad, setOpenNumericPad] = useState(false);
  const [slectedRow, setSelectedRow] = useState<any>(undefined);
  const [currentPadValue, setCurrentPadValue] = useState<string>("0");
  const [barcodeValue, setBarcodeValue] = useState<string>("");
  const [tableFilters, setTableFilters] = useState<{
    filters: any;
    sorter: any;
    extra: any;
    pagination: any;
  }>(DEFAULT_TABLE_FILTERS);

  const [currentStatus, setCurrentStatus] = useState("");
  const isDisabled = currentStatus === "validated";

  const [activePagination, setActivePagination] = useState<{
    current: number;
    pageSize: number;
    showSizeChanger: boolean;
    totalPage: number;
  }>(DEFAULT_ACTIVE_PAGINATION);

  const [matrixArticles, setMatrixArticles] = useState<{
    notRecount: string;
    recount: string;
  }>(DEFAULT_MATRIX_ARTICLES);
  const numberOfMaterialToLoadRef = useRef(numberOfMaterialToLoad);
  // FORM & OTHERS
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();
  const [recountAlarm, setRecountAlarm] = useRecoilState(
    recountAlertAlarmState
  );

  const columnMaterial = [
    {
      title: `${t("MATERIAL")}`,
      key: "materialInfo",
      render: (text: any, record: any, rowIndex: number) => (
        <div>
          <span className="custom-truncate">
            {record.materialInfo?.code} - {record.materialInfo?.description}
          </span>
        </div>
      ),
    },
    {
      title: `${t("MEASURE_UNIT")}`,
      dataIndex: "mesurationUnit",
      key: "measureUnit",
      sorter: (a: any, b: any) =>
        a.measureUnit?.code.localeCompare(b.measureUnit?.code),
      render: (text: any, record: any, rowIndex: number) => (
        <div>
          <span className="custom-truncate">
            {record.measureUnit?.description}
          </span>
        </div>
      ),
    },
    {
      title: `${t("QUANTITY")}`,
      key: "quantity",
      sorter: (a: any, b: any) => a.quantity - b.quantity,
      render: (text: any, record: any, rowIndex: number) => (
        <div>
          <span className="custom-truncate">{record.quantity}</span>
        </div>
      ),
    },
    {
      title: `${t("EFFECTIVE_QUANTITY")}`,
      dataIndex: "effectiveQuantity",
      key: "effectiveQuantity",
      sorter: (a: any, b: any) => a.effectiveQuantity - b.effectiveQuantity,
      render: (text: any, record: any, rowIndex: number) => (
        <Space style={{ minWidth: "9rem" }}>
          <Button
            type="default"
            icon={<MinusOutlined />}
            className="customButtonNoFloat"
            onClick={() => changeQuantity(record, "minus", "effectiveQuantity")}
            disabled={isDisabled}
          />
          <Button
            type="default"
            className="w-20 h-10"
            onClick={() => openNumericPadModal(record)}
            disabled={isDisabled}
          >
            {record.effectiveQuantity}
          </Button>
          <Button
            type="default"
            icon={<PlusOutlined />}
            className="customButtonNoFloat"
            onClick={() => changeQuantity(record, "plus", "effectiveQuantity")}
            disabled={isDisabled}
          />
        </Space>
      ),
    },
    {
      title: " ",
      dataIndex: "actions",
      key: "actions",
      render: (text: any, record: any, rowIndex: number) => (
        <div>
          <Button
            type="primary"
            icon={<DeleteOutlined />}
            style={{ backgroundColor: styles.red, padding: "7px" }}
            className="customButtonNoFloat"
            onClick={() => deleteMaterial(record)}
            disabled={isDisabled}
          />
        </div>
      ),
    },
  ];

  const columnRecount = [
    {
      title: `${t("MATERIAL")}`,
      key: "materialInfo",
      render: (text: any, record: any, rowIndex: number) => (
        <div>
          <span className="custom-truncate">
            {record.materialInfo?.code} - {record.materialInfo?.description}
          </span>
        </div>
      ),
    },
    {
      title: `${t("EFFECTIVE_QUANTITY")}`,
      dataIndex: "effectiveQuantity",
      key: "effectiveQuantity",
    },
    {
      title: `${t("RECOUNT")}`,
      key: "inrecount",
      render: (text: any, record: any, rowIndex: number) => {
        console.log("inrecount", record);

        return (
          <Space style={{ minWidth: "9rem" }}>
            <Button
              icon={<MinusOutlined />}
              className="customButtonNoFloat bg-teal-500 text-white font-black"
              onClick={() => changeQuantity(record, "minus", "recount")}
              disabled={isDisabled}
            />
            <Button
              type="primary"
              className={
                record.outRecount !== 0
                  ? "bg-red-700 w-20 h-10"
                  : "bg-blue-500 w-20 h-10"
              }
              onClick={() => openNumericPadModal(record)}
              disabled={isDisabled}
            >
              {record.inrecount}
            </Button>
            <Button
              icon={<PlusOutlined />}
              className="customButtonNoFloat bg-teal-500 text-white font-black"
              onClick={() => changeQuantity(record, "plus", "recount")}
              disabled={isDisabled}
            />
          </Space>
        );
      },
    },
    {
      title: `${t("DIFFERENCE")}`,
      dataIndex: "outRecount",
      key: "out",
      render: (text: any, record: any, rowIndex: number) => {
        const val = record.outRecount * -1;

        return (
          <div>
            {val >= 1 ? `+` : ""}
            <span className="custom-truncate">
              {val > 1 ? `${val.toString()}` : val}
            </span>
          </div>
        );
      },
    },
  ];

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `${t("MATERIAL")}`,
      children: (
        <div className="sisos-table-container">
          <Table
            dataSource={tableData}
            className="sisos-table"
            columns={columnMaterial}
            pagination={{
              current: activePagination.current,
              pageSize: window.innerWidth > 800 ? 12 : 7,
              showSizeChanger: true,
              total: activePagination.totalPage,
              hideOnSinglePage: true,
              position: ["topCenter"],
              size: "small",
            }}
            size="small"
            onChange={(pagination, filters, sorter: any, extra) => {
              onTableChange(pagination, filters, sorter, extra);
            }}
          />
        </div>
      ),
    },
    {
      key: "2",
      label: `${t("RECOUNT")}`,
      children: (
        <div className="sisos-table-container">
          <Table
            className="sisos-table"
            dataSource={tableData}
            columns={columnRecount}
            size="small"
            pagination={{
              current: activePagination.current,
              pageSize: activePagination.pageSize,
              showSizeChanger: true,
              total: activePagination.totalPage,
              hideOnSinglePage: true,
              position: ["topCenter"],
              size: "small",
            }}
            onChange={(pagination, filters, sorter: any, extra) => {
              onTableChange(pagination, filters, sorter, extra);
            }}
          />
        </div>
      ),
    },
  ];

  const addMaterial = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setMaterialType(undefined);
  };

  useEffect(() => {
    return () => {
      setRecountAlarm({
        status: false,
        recount: { title: "" },
      });
    };
  }, []);

  const handleOkModalNumericPad = () => {
    if (activeKey === TAB_MATERIAL) {
      slectedRow.effectiveQuantity = parseInt(currentPadValue);
    }
    if (activeKey === TAB_RECOUNT) {
      slectedRow.inrecount = parseInt(currentPadValue);
      slectedRow.outRecount =
        slectedRow.effectiveQuantity - parseInt(currentPadValue);
    }
    updateRow(slectedRow);
    resetModalVariables();
  };

  const resetModalVariables = () => {
    setStateKey(stateKey + 1);
    setSelectedRow(undefined);
    setCurrentPadValue("0");
    setOpenNumericPad(false);
  };

  const handleCancelNumericPad = () => {
    resetModalVariables();
  };

  const resetForm = () => {
    form.resetFields();
  };

  function loadMaterialTypesList() {
    const payload: any = [
      {
        field: "t.validityEnd",
        operator: "isValid",
      },
    ];

    let matrixTypesForLookup =
      userInfo.matrixPar["system.monitor.materialsLookupTypes"];
    let types: string[] = [];

    try {
      types = matrixTypesForLookup?.split(",");
      if (!types || types.length === 0) {
        types = [matrixArticles.notRecount, matrixArticles.recount];
      }
    } catch (err) {
      console.log(err);
      types = [matrixArticles.notRecount, matrixArticles.recount];
    }

    if (types && types.length > 0) {
      payload.push({
        field: "t.code",
        operator: "included",
        value: types,
      });
    }

    const queryparams = {
      page: 1,
      take: 50000,
      searchOn: "code,description",
      searchFor: "",
    };

    changeShowLoading(
      MaterialsService.getMaterialTypes(payload, queryparams)
        .then((res) => {
          setMaterialTypesList(res.list);
        })
        .catch((err) => {
          console.error(t("ERROR"), err);
        })
    );
  }

  const initData = async () => {
    changeShowLoading(
      EquipeService.loadData({
        uuid: sharedInfo.surgery,
        tabName: "operators-tab",
      }).then((resp) => {
        setCurrentStatus(resp?.currentStatus || "");
      })
    );
  };

  React.useEffect(() => {
    initData();
  }, []);


  function loadMaterialList(filter: string): void {
    const payload: Array<{
      field: string;
      operator: string;
      value?: string | string[];
    }> = [
        {
          field: "t.validityEnd",
          operator: "isValid",
        },
      ];

    if (materialTypeForFilter) {
      payload.push({
        field: "article_type.code",
        operator: "equal",
        value: materialTypeForFilter,
      });
    } else {
      payload.push({
        field: "article_type.code",
        operator: "included",
        value: [matrixArticles.notRecount, matrixArticles.recount],
      });
    }

    const queryparams = {
      page: 1,
      take: filter === "" ? numberOfMaterialToLoadRef.current : 50000,
      searchOn: "code,description",
      searchFor: filter,
    };

    changeShowLoading(
      MaterialsService.getMaterials(payload, queryparams)
        .then((res) => {
          setMaterialList(res.list);
          setMaterialListLength(res.totalResults);
        })
        .catch((err) => {
          console.error(t("ERROR"), err);
        })
    );
  }

  const loadData = () => {
    let page, pageSize;
    let params = "";

    let payload = [
      {
        field: "surgery_management.uuid",
        operator: "equal",
        value: sharedInfo.surgery,
      },
    ];

    if (activeKey === TAB_RECOUNT) {
      // se sto chiamando la tab del riconteggio
      payload.push({
        field: "material_material_type.code",
        operator: "equal",
        value: matrixArticles.recount,
      });

      // payload.push({
      //   field: "t.effectiveQuantity",
      //   operator: "gtEqual",
      //   value: "1",
      // });
    }

    page = tableFilters?.pagination?.current || activePagination.current;
    pageSize = tableFilters?.pagination?.pageSize || activePagination.pageSize;

    if (searchFilter) {
      params += `&searchOn=material_material.description,material_material.code&searchFor=${searchFilter}`;
    }

    if (
      tableFilters.sorter &&
      tableFilters.sorter.columnKey &&
      tableFilters.sorter.order
    ) {
      params += `&order=${REMAPPED_FIELDS[tableFilters.sorter.columnKey]}:${tableFilters.sorter.order === "ascend" ? "ASC" : "DESC"
        }`;
    } else {
      // order for description by default
      params += `&order=${REMAPPED_FIELDS["materialInfoDescription"]}:ASC`;
    }

    changeShowLoading(
      MaterialsService.loadData(payload, page, pageSize, params)
        .then((res) => {
          // if (activeKey === TAB_RECOUNT) {
          estimateDifference(res.list);
          // }

          console.log(
            res.list.filter(
              (item: any) => item.materialType.code === matrixArticles.recount
            )
          );

          const hasOutRecount: any = res.list.find(
            (item: any) =>
              item.outRecount !== 0 &&
              item.materialType.code === matrixArticles.recount
          );

          if (hasOutRecount) {
            setRecountAlarm({
              recount: { title: hasOutRecount?.label },
              status: true,
            });
          } else {
            setRecountAlarm({
              recount: { title: "" },
              status: false,
            });
          }

          res.list.map((el: Record<string, any>) => {
            el.value = el.materialInfo.uuid;
            el.instrumentCode = el.materialInfo.code;
            el.label = el.materialInfo.description;
          });

          setTableData(res.list);
          setActivePagination({
            current: parseInt(res.page),
            pageSize: parseInt(res.pageSize),
            showSizeChanger: true,
            totalPage: res.totalResults,
          });
        })
        .catch((err) => {
          console.error(err);
        })
    ).finally(() => {
      setSearchData(false);
    });
  };

  const estimateDifference = (data: any) => {
    (data || []).forEach((element: any) => {
      element.outRecount = element.effectiveQuantity - element.inrecount;
    });

    return data;
  };

  const onTableChange = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any
  ) => {
    console.log("Tab has changed", pagination, filters, sorter, extra);
    setTableFilters({ filters, sorter, extra, pagination });
  };

  const deleteMaterial = (record: any) => {
    if (
      userInfo.capabilities["CAN_EDIT_ALL_TAB"] ||
      userInfo.capabilities["CAN_EDIT_MATERIALS_TAB"]
    ) {
      changeShowLoading(
        MaterialsService.deleteMaterial(record.uuid)
          .then(() => {
            loadData();
          })
          .catch((err) => {
            console.error(err);
          })
      );
    } else {
      <Alert
        message={t("PERMISSION_NEGATE")}
        type="warning"
        showIcon
        closable
      />;
    }
  };

  const onTabChange = (activeKey: string) => {
    setTableData([]);
    resetActivePagination();
    resetTableFilters();
    setActiveKey(activeKey);
  };

  const resetActivePagination = () => {
    setActivePagination(DEFAULT_ACTIVE_PAGINATION);
  };

  const resetTableFilters = () => {
    setTableFilters({
      filters: {},
      sorter: {},
      extra: {},
      pagination: {},
    });
  };

  const setManualEffectiveQty = (e: any, record: any) => {
    // check if the value is a number using regex
    if (!/^[0-9]*$/.test(e.target.value) || !e.target.value) {
      return;
    }

    let manualQty = e.target?.value ? parseInt(e.target.value) : 0;
    let indexEl = tableData.findIndex((item) => item.uuid === record.uuid);

    if (manualQty < 0) {
      return;
    }

    tableData[indexEl].effectiveQuantity = manualQty;
    refreshTableData(tableData);
  };

  const refreshTableData = (data: any) => {
    tableData = [...data];
    console.log("refreshTableData", tableData);
    const hasOutRecount: any = tableData.find(
      (item) =>
        item.outRecount !== 0 &&
        item.materialType.code === matrixArticles.recount
    );
    if (hasOutRecount) {
      setRecountAlarm({
        recount: { title: hasOutRecount?.label },
        status: true,
      });
    } else {
      setRecountAlarm({
        recount: { title: "" },
        status: false,
      });
    }
    setTableData(tableData);
  };

  const updateRow = (record: any) => {
    let indexEl = tableData.findIndex((item) => item.uuid === record.uuid);
    changeShowLoading(
      MaterialsService.update(tableData[indexEl].uuid, tableData[indexEl])
        .then(() => {
          refreshTableData(tableData);
        })
        .catch((err) => {
          console.error(err);
        })
    );
  };

  const changeQuantity = (record: any, operation: string, type: string) => {
    let count = 0;

    console.log(
      "qui",
      userInfo.capabilities["CAN_EDIT_ALL_TAB"],
      userInfo.capabilities["CAN_EDIT_MATERIALS_TAB"]
    );
    if (
      !userInfo.capabilities["CAN_EDIT_ALL_TAB"] ||
      !userInfo.capabilities["CAN_EDIT_MATERIALS_TAB"]
    ) {
      <Alert
        message={t("PERMISSION_NEGATE")}
        type="warning"
        showIcon
        closable
      />;
      return;
    }

    if (operation === "plus") count++;
    if (operation === "minus") count--;

    let indexEl = tableData.findIndex((item) => item.uuid === record.uuid);

    if (indexEl === -1) return; // se non trovo l'elemento esco

    if (
      type === "effectiveQuantity" &&
      ((tableData[indexEl].effectiveQuantity >= 0 && count === 1) ||
        tableData[indexEl].effectiveQuantity > 0)
    ) {
      tableData[indexEl].effectiveQuantity =
        tableData[indexEl].effectiveQuantity + count;
    } else if (
      type === "recount" &&
      ((tableData[indexEl].inrecount >= 0 && count === 1) ||
        tableData[indexEl].inrecount > 0)
    ) {
      tableData[indexEl].inrecount = tableData[indexEl].inrecount + count;
      tableData[indexEl].outRecount =
        tableData[indexEl].effectiveQuantity - tableData[indexEl].inrecount;
    }

    console.log("tableData", tableData);

    refreshTableData(tableData);
    updateRow(record);
  };

  const saveNewElement = async (element: any) => {
    const isValid = await form.validateFields().catch(() => false);
    if (!isValid) return;

    if (
      userInfo.capabilities["CAN_EDIT_ALL_TAB"] ||
      userInfo.capabilities["CAN_EDIT_MATERIALS_TAB"]
    ) {
      changeShowLoading(
        MaterialsService.createMaterial(element)
          .then(() => {
            setIsModalOpen(false);
            loadData();
          })
          .catch((err) => {
            console.error(err);
          })
      );
    } else {
      <Alert
        message={t("PERMISSION_NEGATE")}
        type="warning"
        showIcon
        closable
      />;
    }
  };

  const handleOk = () => {
    let data = form.getFieldsValue();
    data = {
      uuid: sharedInfo.surgery,
      inrecount: 0,
      material: data.material,
      quantity: parseInt(data.quantity) ? parseInt(data.quantity) : 0,
      effectiveQuantity: parseInt(data.quantity) ? parseInt(data.quantity) : 0,
      outRecount: 0,
    };

    saveNewElement(data);
  };

  const barcodeShot = (value: any) => {
    // console.log(value)
    const foundItem = tableData.find(
      (item) => item.materialInfo.code === value
    );
    if (foundItem) {
      changeQuantity(foundItem, "plus", "effectiveQuantity");
      message.success(t("BARCODE_FOUND_QUANTITY_INCREMENTED"));
      barcodeForm.setFieldsValue({ barcode: "" });
    }
  };

  const onSearch = (value: any) => {
    console.log(value);
    // svuoto i filtri e la paginazione attiva
    resetActivePagination();
    resetTableFilters();
    // imposto il nuovo valore di ricerca
    setSearchFilter(value);
    setSearchData(true);
  };

  const onSearchCleared = (value?: any) => {
    console.log(value);
    // svuoto i filtri e la paginazione attiva
    resetActivePagination();
    resetTableFilters();
    // imposto il nuovo valore di ricerca
    setSearchFilter("");
    setSearchData(true);
  };

  React.useEffect(() => {
    numberOfMaterialToLoadRef.current = numberOfMaterialToLoad;
    loadMaterialList(searchFilter); // Trigger loadMaterialList when numberOfMaterialToLoad changes
  }, [numberOfMaterialToLoad]);

  const onScroll = (value: any) => {
    if (materialListLength <= numberOfMaterialToLoad) {
      return;
    }
    const target = value.target;
    if (Math.abs(target.scrollTop + target.offsetHeight - target.scrollHeight) < 1) {
      setNumberOfMaterialToLoad((prev) => prev + 50);
    }
  };

  const onSearchQTMoreThanOne = (value: any) => {
    if (value) {
      const filteredData = tableData.filter((item) => item.quantity >= 1);
      setTableData(filteredData);
    } else {
      loadData();
    }
  };

  const onSearchValue = (value: any) => {
    loadMaterialList(value);
  };

  const loadMatrixValue = () => {
    let matrix = userInfo.matrixPar["system.articles"];

    try {
      let info = JSON.parse(matrix);

      info = {
        notRecount: info.notRecount,
        recount: info.recount,
      };

      setMatrixArticles(info);
    } catch (error) {
      console.log(error);
    }
  };

  const onPadChange = (value: string) => {
    setCurrentPadValue(value);
  };

  const openNumericPadModal = (record: any) => {
    if (
      !userInfo.capabilities["CAN_EDIT_ALL_TAB"] ||
      !userInfo.capabilities["CAN_EDIT_MATERIALS_TAB"]
    ) {
      <Alert
        message={t("PERMISSION_NEGATE")}
        type="warning"
        showIcon
        closable
      />;
      return;
    }
    if (record) {
      setSelectedRow(record);
      if (record.effectiveQuantity) {
        setCurrentPadValue(record.effectiveQuantity + "");
      }
      setOpenNumericPad(true);
    }
  };

  React.useEffect(() => {
    loadMaterialList("");
  }, [materialTypeForFilter]);

  // USE EFFECTS
  React.useEffect(() => {
    loadMatrixValue();
  }, []);

  React.useEffect(() => {
    loadMaterialTypesList();
  }, [matrixArticles]);

  React.useEffect(() => {
    loadData();
  }, [
    matrixArticles,
    activeKey,
    searchFilter,
    tableFilters,
    isModalOpen === false,
  ]);

  React.useEffect(() => {
    if (isModalOpen) loadMaterialList("");
    if (!isModalOpen) resetForm();
  }, [isModalOpen]);

  // RENDER
  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleOk}
        closable={false}
        maskClosable={false}
        okButtonProps={{ disabled: materialType ? false : true }}
      >
        <div className="form-container">
          <Form
            name="normal_login"
            className="sisos-form"
            form={form}
            layout="horizontal"
            labelCol={{
              span: 7,
            }}
            wrapperCol={{
              span: 20,
            }}
          >
            <Form.Item name="material-type" label={t("MATERIAL_TYPE")}>
              <Select
                showSearch
                className="w-full"
                placeholder={t("SELECT_MATERIAL_TYPE")}
                optionFilterProp="children"
                fieldNames={{ label: "description", value: "code" }}
                onChange={(value) => {
                  form.resetFields(["material"]);
                  setMaterialTypeForFilter(value);
                  setNumberOfMaterialToLoad(50);
                }}
                filterOption={false}
                options={materialTypesList}
              ></Select>
            </Form.Item>

            <Form.Item
              name="material"
              className="form-container-item"
              label={t("MATERIAL")}
              rules={[
                {
                  required: true,
                  message: `${t("REQUIRED_FIELD")}`,
                },
              ]}
            >
              <Select
                showSearch
                className="w-full"
                placeholder={t("SELECT_MATERIAL")}
                optionFilterProp="children"
                fieldNames={{ label: "description", value: "uuid" }}
                onChange={(e) => setMaterialType(e)}
                onPopupScroll={onScroll}
                onSearch={onSearchValue}
                allowClear
                filterOption={(input, option: any) =>
                  option.description
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                options={materialList}
              />
            </Form.Item>

            <Form.Item
              name="quantity"
              className="form-container-item"
              label={t("QUANTITY")}
            >
              <InputNumber
                size="large"
                type="number"
                stringMode
                min="1"
                defaultValue="1"
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
      {/* <Space align="end" className="pullRight">
        <Search
          placeholder={`${t("MATERIAL_FILTER")}`}
          onSearch={onSearch}
          enterButton
          style={{ width: 304 }}
          loading={searchData}
          allowClear
        />

        <Button
          type="primary"
          className="customButton"
          style={{ backgroundColor: styles.orange }}
          onClick={addMaterial}
        >
          <PlusOutlined />
        </Button>
      </Space> */}{" "}
      <div className=""></div>
      <div className="page-container-margin">
        <div
          style={{ borderBottom: "1px solid #EEE" }}
          className="flex w-full justify-between items-center border-opacity-30 pb-4 text-left"
        >
          <div className="flex w-4/6 justify-between items-center">
            <Select
              className="w-full w-4/6 mr-4"
              showSearch
              onSearch={onSearch}
              onSelect={(el) => onSearch(el.label)}
              options={tableData}
              placeholder={t("FILTER_MATERIALS_LIST")}
              labelInValue
              key="material-search-filter"
              allowClear
              onClear={onSearchCleared}
              filterOption={false}
              suffixIcon={<SearchOutlined />}
            ></Select>

            <div className="w-2/6">
              <Form
                form={barcodeForm}
                style={{
                  margin: 0,
                  padding: 0,
                }}
              >
                <Form.Item
                  style={{
                    margin: 0,
                    padding: 0,
                  }}
                  name="barcode"
                >
                  <Input
                    name="barcode"
                    className="w-full pr-3"
                    addonBefore={<BarcodeOutlined className="text-teal-700" />}
                    addonAfter={<SearchOutlined className="text-teal-700" />}
                    placeholder={t("SEARCH")}
                    style={{ width: "300px" }}
                    autoFocus={true}
                    onKeyUp={(e: any) => {
                      if (e.key === "Enter") {
                        barcodeShot(e.target.value);
                      }
                    }}
                  // onChange={(e) => barcodeShot(e.target.value)}
                  // onSubmit={(e) => barcodeShot(e.target)}
                  ></Input>
                </Form.Item>
              </Form>
            </div>
          </div>
          <div
            style={{
              borderRight: "1px dashed #AAA",
            }}
            className="h-8 w-1 border-gray-300 mr-4"
          ></div>
          <div className="flex items-center">
            <span className="text-teal-700 font-black mr-2">{"QT ≥ 1"}</span>
            <Switch
              onChange={(checked) => onSearchQTMoreThanOne(checked)}
              className="customSwitch"
              title={t("SHOW_ONLY_QUANTITY_GREATER_THAN_ONE")}
            />
          </div>
          <Button
            type="primary"
            icon={<PlusCircleFilled />}
            className="customButton"
            style={{ backgroundColor: styles.buttonTeal }}
            onClick={addMaterial}
            disabled={isDisabled}
          >
            {t("ADD_MATERIAL")}
          </Button>
        </div>

        <Modal
          open={openNumericPad}
          onCancel={handleCancelNumericPad}
          onOk={handleOkModalNumericPad}
          closable={false}
          maskClosable={false}
        >
          {activeKey === TAB_MATERIAL ? (
            <>
              <NumericPad
                key={stateKey}
                onResultChange={onPadChange}
                value={slectedRow?.effectiveQuantity + ""}
              />
            </>
          ) : (
            ""
          )}

          {activeKey === TAB_RECOUNT ? (
            <>
              <NumericPad
                key={stateKey}
                onResultChange={onPadChange}
                value={slectedRow?.inrecount + ""}
              />
            </>
          ) : (
            ""
          )}
        </Modal>

        <Tabs
          onChange={(activeKey: string) => onTabChange(activeKey)}
          defaultActiveKey={TAB_MATERIAL}
          items={items}
          size="small"
        />
      </div>
    </>
  );
}

export default Materials;
